import type { SelectHTMLAttributes } from "react";
import styles from "./Select.module.css";
import { cx } from "./cx.js";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

/**
 * The platform's select, restyled rather than rebuilt.
 *
 * A custom listbox is a week of keyboard and screen-reader work, and on a
 * phone the native control is the better one anyway — it opens as a wheel the
 * user already knows how to drive.
 */
export function Select({ invalid, className, children, ...rest }: SelectProps) {
  return (
    <div className={styles.wrapper}>
      <select
        className={cx(
          styles.select,
          (invalid || rest["aria-invalid"]) && styles.invalid,
          className,
        )}
        {...rest}
      >
        {children}
      </select>
      <svg className={styles.chevron} viewBox="0 0 16 16" aria-hidden="true">
        <path
          d="M4 6l4 4 4-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
